export default __webpack_public_path__ + "static/media/i_bus-tro_gn_tagless.a5d51a38.svg";